jQuery(function ($) {
  const $banner = $("#cookies_her");
  const cookieKey = "her_cookie";

  if (localStorage.getItem(cookieKey)) {
  } else {
    $banner.addClass("show").hide().fadeIn(300);
  }

  function handleChoice(e) {
    e.preventDefault();
    localStorage.setItem(cookieKey, "true");
    $banner.fadeOut(200, function () {
      $banner.removeClass("show").addClass("hide");
    });
  }

  $("#cookies_ok, #cookies_reject").on("click", handleChoice);

  //links footer

  $(".footer__menu a").attr({
    target: "_blank",
    rel: "noopener",
  });
});
